import React from 'react'

import ChatListHeader from './chat_list_header'
import ChatCurrentUserBar from '../shared/chat_current_user_bar'
import ChatList from './chat_list.js'
import ConversationsStack from './conversations_stack'
import ModalDirector from '../shared/modal_director'
import ReportModal from '../shared/report_modal'
import UserProfileModal from '../shared/user_profile_modal'
import SessionInitiateModal from '../shared/session_initiate_modal'
import SessionRequestModal from '../shared/session_request_modal'
import GroupChatsModal from '../shared/group_chats_modal'
import GroupChatSubscriptionModal from '../shared/group_chat_subscription_modal'

class ChatUIDesktop extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      toggled: true
    }

    this.modalsList = {
      report: ReportModal,
      userProfile: UserProfileModal,
      sessionInitiate: SessionInitiateModal,
      sessionRequest: SessionRequestModal,
      groupChats: GroupChatsModal,
      groupSubscribe: GroupChatSubscriptionModal
    }
  }

  renderConversationsStack () {
    return (
      <ConversationsStack {...this.props} />
    )
  }

  toggle () {
    this.setState({toggled: !this.state.toggled})
  }

  renderChatList () {
    const isMinimized = !this.state.toggled

    if (this.state.toggled) {
      return (
        <div className="chat-list-desktop-container">
          <ChatListHeader onClick={this.toggle.bind(this)} {...this.props} isMinimized={isMinimized}/>
          <ChatCurrentUserBar/>
          <ChatList className="desktop" {...this.props}/>
        </div>
      )
    }
    else {
      return (
        <div className="chat-list-desktop-container minified">
          <ChatListHeader onClick={this.toggle.bind(this)} {...this.props} isMinimized={isMinimized}/>
        </div>
      )
    }
  }

  renderModalView () {
    return <ModalDirector modalsList={this.modalsList}/>
  }

  render () {
    return (
      <div className='chat-ui-desktop'>
        {this.renderConversationsStack()}
        {this.renderChatList()}
        {this.renderModalView()}
      </div>
    )
  }
}

export default ChatUIDesktop



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_ui.desktop.js
 **/